import { useLocation, Link, useParams } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const { lang = "en" } = useParams<{ lang?: string }>();

  const homePath = lang ? `/${lang}/` : "/";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <h1 className="text-8xl md:text-9xl font-black text-background-200 select-none pointer-events-none mb-4 font-heading">
        404
      </h1>
      <div className="relative z-10 max-w-lg">
        <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-4">
          Page Not Found
        </h2>
        <p className="mt-2 text-sm text-foreground-500 font-mono bg-background-100 px-3 py-1 rounded inline-block">
          {location.pathname}
        </p>
        <p className="mt-4 text-base md:text-lg text-foreground-600">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to={homePath}
          className="btn-primary mt-6 inline-flex"
        >
          <i className="ri-home-line mr-2" />
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}